import { render, staticRenderFns } from "./NewDTextareaEditor.vue?vue&type=template&id=03e63c3c&"
import script from "./NewDTextareaEditor.vue?vue&type=script&lang=js&"
export * from "./NewDTextareaEditor.vue?vue&type=script&lang=js&"
import style0 from "./NewDTextareaEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports